import { z } from "zod";
/**
 * Public website enquiry payload. Submitted by the unauthenticated
 * marketing-site form to POST /api/enquiry.
 *
 * `website` is a honeypot field: real users never see it (it is
 * positioned off-screen via CSS), so a non-empty value indicates a
 * bot. The route silently returns 200 rather than 400 so bots get no
 * signal.
 *
 * Revision 2026-05-30b: `mobile`, `country`, and `industry` are all
 * required. `mobile` maps to the contact's `phone` column; `country`
 * and `industry` go into `customFields` jsonb (no first-class CRM
 * columns exist for them yet).
 */
export const PublicEnquirySchema = z.object({
    firstName: z.string().min(1).max(100),
    lastName: z.string().min(1).max(100),
    email: z.string().email().toLowerCase(),
    company: z.string().max(200).optional(),
    mobile: z.string().min(1).max(30),
    country: z.string().min(1).max(60),
    industry: z.string().min(1).max(80),
    message: z.string().max(5000).optional(),
    marketingConsent: z.boolean().default(false),
    turnstileToken: z.string().min(1),
    website: z.string().max(0).optional().default(""),
});
//# sourceMappingURL=enquiry.js.map